"use client";

import { PropsWithChildren } from "react";
import { useTabInfo } from "@/utils/hooks/useTabsContext";

interface TabProps {
  value: string;
}
export default function Tab({ value, children }: PropsWithChildren<TabProps>) {
  const { activeTab } = useTabInfo();
  if (value === activeTab) {
    return children;
  }
  return null;
}
